// @ts-strict-ignore
// .rename-input is another tab trap we need to avoid here
const focusableSelector = "input:not(.rename-input), button, a, area, object, select, textarea, [contenteditable]";

const isTabbable = (el: HTMLElement, inputElement: HTMLElement): boolean => {
  if (el === inputElement) {
    return true;
  }
  // Skip Monaco's own widgets, e.g. the hidden suggest-list links it leaves in the DOM
  if (el.closest(".monaco-editor")) {
    return false;
  }
  if (el.tabIndex < 0 || el.matches(":disabled")) {
    return false;
  }
  return el.getClientRects().length > 0;
};

const getTabbableElements = (inputElement: HTMLElement) =>
  [...document.querySelectorAll<HTMLElement>(focusableSelector)].filter((el) => isTabbable(el, inputElement));

const moveFocus = (inputElement: HTMLElement, offset: 1 | -1) => {
  const tabbableElements = getTabbableElements(inputElement);
  const currentIndex = tabbableElements.indexOf(inputElement);
  // Wrap around at either end of the page
  const targetIndex = (currentIndex + offset + tabbableElements.length) % tabbableElements.length;
  tabbableElements[targetIndex].focus();
};

export const emulateTabBehaviorInMonaco = ({ editor, inputElement, monaco }) => {
  if (!inputElement) {
    return;
  }
  // Monaco has a bug where commands are only added to the last instance, which
  // is why we need to re-add commands when an editor is focused
  // https://github.com/microsoft/monaco-editor/issues/2947
  editor.onDidFocusEditorText(() => {
    // While the autocomplete list is open, leave Tab to Monaco so it accepts the selected suggestion
    editor.addCommand(monaco.KeyCode.Tab, () => moveFocus(inputElement, 1), "!suggestWidgetVisible");

    editor.addCommand(monaco.KeyMod.Shift | monaco.KeyCode.Tab, () => moveFocus(inputElement, -1));
  });
};
